import * as $ from "jquery";

$(function() {
    $('table').on('click', 'td', function() {
        if ($(this).parent().data('href') && !$(this).hasClass("actions")) {
            window.location = $(this).parent().data('href');
        }
    });
});
